(() => {
  if (customElements.get('vp-size-finder')) return;
  const letters = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[c]));
  const numberSize = value => {
    const text = String(value).trim();
    const match = text.match(/\bEU\s*(\d{2}(?:[.,]\d+)?)/i) || text.match(/^(\d{2}(?:[.,]\d+)?)\s*(?:EU)?$/i);
    return match ? Number(match[1].replace(',', '.')) : null;
  };
  const stepsFor = (kind, parts) => kind === 'hoodie' ? ['gender','usual'] : kind === 'tracksuit' ? [...(parts[0].kids || parts[1].kids ? ['height'] : []), ...(parts[0].kids ? [] : ['gender','hoodieSize']), ...(parts[1].kids ? [] : ['pantsSize'])] : kind === 'tee' ? ['usual','fit'] : ['usual'];
  function resolveVariant(data, usual, delta, shoe) {
    const sizeIndex = data.sizeIndex || 0;
    let target;
    if (data.kids) {
      const height = Number(usual);
      const matches = data.variants.filter(v => v.options.every((value,i) => i === sizeIndex || value === data.selectedOptions[i]))
        .map(variant => ({variant, range: String(variant.options[sizeIndex]).match(/(\d+)\s*[-–]\s*(\d+)\s*cm/i)}))
        .filter(({range}) => range && height >= Number(range[1]) && height <= Number(range[2]))
        .sort((a,b) => Number(b.range[1]) - Number(a.range[1]));
      const variant = matches[0]?.variant;
      return {label: variant?.options[sizeIndex] || '—', variant};
    }
    if (shoe) {
      const n = numberSize(usual);
      if (n === null) return {label: String(usual), variant:null};
      target = n + delta;
    } else {
      const position = letters.indexOf(String(usual).toUpperCase());
      target = position < 0 ? null : letters[position + delta];
      if (!target) return {label:'—',variant:null,belowMinimum:position >= 0 && position + delta < 0};
    }
    const others = data.selectedOptions || data.variants[0]?.options || [];
    const candidates = data.variants.filter(v => v.options.every((o,i) => i === sizeIndex || o === others[i]));
    const matches = candidates.filter(v => shoe ? numberSize(v.options[sizeIndex]) === target : String(v.options[sizeIndex]).trim().toUpperCase() === target);
    if (!matches.length && shoe && delta !== 0) {
      const values = [...new Set(candidates.map(v => numberSize(v.options[sizeIndex])).filter(n => n !== null))];
      const next = delta > 0 ? values.filter(n => n >= target && n - target <= .5).sort((a,b)=>a-b)[0] : values.filter(n => n <= target && target - n <= .5).sort((a,b)=>b-a)[0];
      if (next !== undefined) matches.push(...candidates.filter(v => numberSize(v.options[sizeIndex]) === next));
    }
    const variant = matches.find(v => v.available) || matches[0] || null;
    const letterPositions = candidates.map(v => letters.indexOf(String(v.options[sizeIndex]).trim().toUpperCase())).filter(i => i >= 0);
    const belowMinimum = !shoe && letterPositions.length > 0 && letters.indexOf(target) < Math.min(...letterPositions);
    return {label:variant ? variant.options[sizeIndex] : shoe ? 'EU '+target : target, variant, belowMinimum};
  }
  class VuoplugSizeFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-vp-sf-config]');
      if (!config) return;
      this.cfg = JSON.parse(config.textContent);
      this.t = this.cfg.i18n;
      this.ready = true;
      this.root = this.cfg.root.endsWith('/') ? this.cfg.root : this.cfg.root + '/';
      this.querySelector('[data-vp-sf-open]').addEventListener('click', () => this.openGuide());
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.dialog?.remove();
      this.dialog = null;
    }
    money(value) {
      return new Intl.NumberFormat(this.cfg.locale, {style:'currency',currency:this.cfg.currency}).format(value / 100);
    }
    ensureDialog() {
      if (this.dialog) return;
      this.dialog = document.createElement('dialog');
      this.dialog.className = 'vp-sf__dialog';
      const id = 'vp-sf-heading-' + Math.random().toString(36).slice(2);
      this.dialog.setAttribute('aria-labelledby', id);
      this.dialog.innerHTML = `<header class="vp-sf__header"><h2 id="${id}"></h2><div class="vp-sf__controls"><span class="vp-sf__step"></span><button type="button" class="vp-sf__close" data-sf-close aria-label="${escape(this.t.close)}">×</button></div></header><div class="vp-sf__body"></div>`;
      this.body = this.dialog.querySelector('.vp-sf__body');
      const template = this.querySelector('[data-vp-sf-payments]');
      this.payments = (template?.innerHTML || '').replace(/\b(id|aria-labelledby)="([^"]+)"/g, (_,a,b)=>`${a}="${id}-${b}"`);
      this.dialog.addEventListener('click', event => this.handleClick(event));
      this.dialog.addEventListener('submit', event => {
        if (!event.target.matches('[data-sf-height]')) return;
        event.preventDefault();
        this.answer(event.target.elements.height.value);
      });
      this.dialog.addEventListener('change', event => {
        if (event.target.matches('[data-sf-other]') && event.target.value) this.answer(event.target.value);
      });
      this.dialog.addEventListener('close', () => { this.openToken = null; });
      document.body.append(this.dialog);
    }
    setHeader(title, step = '') {
      this.dialog.querySelector('h2').textContent = title;
      this.dialog.querySelector('.vp-sf__step').textContent = step;
    }
    brand(title = this.cfg.title) {
      return `${this.cfg.logo ? `<img class="vp-sf__logo" src="${escape(this.cfg.logo)}" width="37" height="37" alt="Vuoplug">` : ''}<p class="vp-sf__context">${escape(title)}</p>`;
    }
    currentOptions(data, form) {
      const options = [...(data.selectedOptions || data.variants[0]?.options || [])];
      if (form) {
        const fields = new FormData(form);
        options.forEach((_,i) => { const v = fields.get('option'+(i+1)); if (v) options[i] = String(v); });
      }
      return options;
    }
    async openGuide() {
      this.ensureDialog();
      this.answers = {};
      this.step = 0;
      this.result = null;
      this.items = null;
      this.busy = false;
      const token = {};
      this.openToken = token;
      this.setHeader(this.t.title);
      this.dialog.showModal();
      if (this.cfg.kind === 'tracksuit') {
        this.body.innerHTML = `<p class="vp-sf__notice" role="status">${escape(this.t.loading)}</p>`;
        try {
          const wrapper = this.closest('.product-info')?.querySelector('[data-bundle-picker]');
          const slots = wrapper ? [...wrapper.querySelectorAll('[data-bundle-slot]')] : [];
          this.bundleWrapper = wrapper;
          if (slots.length !== 2 || slots.some(slot => !slot.querySelector('[data-addon-card].is-selected'))) {
            this.selectSetMessage(this.t.select_set);
            return;
          }
          const parts = await Promise.all(slots.map(async slot => {
            const card = slot.querySelector('[data-addon-card].is-selected');
            const panel = slot.nextElementSibling?.querySelector(`[data-size-panel-product="${CSS.escape(card.dataset.productId)}"]`);
            const form = panel?.querySelector('form');
            const handle = panel?.querySelector('variant-picker')?.getAttribute('handle');
            if (!handle || !form) throw new Error(this.t.error);
            const response = await fetch(this.root+'products/'+encodeURIComponent(handle)+'.js', {headers:{Accept:'application/json'}});
            if (!response.ok) throw new Error(this.t.error);
            const p = await response.json();
            let sizeIndex = p.options.findIndex(o => /size|koko|größe|izmērs/i.test(typeof o === 'string' ? o : o.name));
            if (sizeIndex < 0) sizeIndex = 0;
            const data = {handle,kids:/kids|junior|lasten|toddler/i.test(handle+' '+card.dataset.productTitle),title:card.dataset.productTitle,sizeIndex,form,card,selectedOptions:p.variants[0]?.options,variants:p.variants.map(v => {
              const input = [...form.elements].find(e => e.name === 'option'+(sizeIndex+1) && e.value === v.options[sizeIndex]);
              return {id:v.id,options:v.options,available:v.available,price:v.price,compare:v.compare_at_price||0,fast:!!(v.available && input && input.dataset.ispreorder !== 'true' && input.dataset.isincoming !== 'true')};
            })};
            data.selectedOptions = this.currentOptions(data,form);
            return data;
          }));
          if (this.openToken !== token || !this.dialog.open) return;
          const hoodie = parts.find(p => /hoodie|huppari|hooded|hood-/i.test(p.title));
          const pants = parts.find(p => /pant|housu|hose|biks/i.test(p.title));
          if (!hoodie || !pants || hoodie === pants || !parts.every(p => /essentials/i.test(p.title))) {
            this.selectSetMessage(this.t.bundle_mismatch);
            return;
          }
          this.parts = [hoodie,pants];
        } catch (error) {
          if (this.openToken !== token || !this.dialog.open) return;
          this.selectSetMessage(error.message || this.t.error);
          return;
        }
      } else {
        const form = document.getElementById(this.dataset.form);
        this.data = {...this.cfg,form,selectedOptions:this.currentOptions(this.cfg,form)};
      }
      this.renderQuestion();
    }
    selectSetMessage(message) {
      this.setHeader(this.t.title);
      this.body.innerHTML = `${this.brand()}<p class="vp-sf__notice">${escape(message)}</p><button type="button" class="vp-sf__add" data-sf-set>${escape(this.t.select_products)}</button>`;
    }
    renderQuestion() {
      const steps = stepsFor(this.cfg.kind, this.parts), key = steps[this.step];
      this.setHeader(this.t.title, `${this.step+1} / ${steps.length}`);
      let question = this.t.usual, content;
      if (key === 'height') {
        question = ({fi:'Lapsen pituus (cm)',sv:'Barnets längd (cm)',de:'Körpergröße des Kindes (cm)',lv:'Bērna augums (cm)'})[this.cfg.locale.split('-')[0]] || 'Child’s height (cm)';
        content = `<form data-sf-height><input name="height" type="number" min="1" step="any" required aria-label="${escape(question)}" placeholder="140" style="border:1px solid #aaa;border-radius:8px;padding:10px;width:100%"><button class="vp-sf__add" type="submit">${escape(this.t.result)}</button></form>`;
      } else if (key === 'gender') {
        question = this.t.gender;
        content = `<div class="vp-sf__choices vp-sf__choices--gender"><button type="button" data-sf-answer="men">${escape(this.t.men)}</button><button type="button" data-sf-answer="women">${escape(this.t.women)}</button></div>`;
      } else if (key === 'fit') {
        question = this.t.fit;
        content = `<div class="vp-sf__fit-options">${['regular','oversized'].map(f=>`<button type="button" class="vp-sf__fit" data-sf-answer="${f}"><strong>${escape(this.t[f])}</strong><span>${escape(this.t[f+'_help'])}</span></button>`).join('')}</div>`;
      } else {
        const shoe = this.cfg.kind === 'shoe';
        question = shoe ? this.t.shoe : key === 'hoodieSize' ? this.t.hoodie : key === 'pantsSize' ? this.t.pants : this.t.usual;
        const values = shoe ? Array.from({length:12},(_,i)=>String(36+i)) : /bape|a bathing ape/i.test(this.cfg.title) ? ['S','M','L','XL'] : letters;
        content = `<div class="vp-sf__choices">${values.map(s=>`<button type="button" data-sf-answer="${s}">${s}</button>`).join('')}</div>`;
        if (shoe) content += `<details class="vp-sf__other"><summary>${escape(this.t.other)}</summary><select data-sf-other aria-label="${escape(this.t.shoe)}"><option value="">${escape(this.t.choose)}</option>${Array.from({length:43},(_,i)=>34+i*.5).map(n=>`<option value="${n}">EU ${String(n).replace('.',this.cfg.locale==='en'?'.':',')}</option>`).join('')}</select></details>`;
      }
      this.body.innerHTML = `${this.brand()}<h3 class="vp-sf__question" tabindex="-1">${escape(question)}</h3>${content}${this.step?`<button type="button" class="vp-sf__back" data-sf-back>${escape(this.t.back)}</button>`:''}`;
      this.dialog.scrollTop = 0;
      this.body.querySelector('h3').focus({preventScroll:true});
    }
    answer(value) {
      const steps = stepsFor(this.cfg.kind, this.parts);
      this.answers[steps[this.step]] = value;
      if (this.step < steps.length-1) { this.step++; this.renderQuestion(); }
      else this.renderResult();
    }
    renderResult() {
      const a = this.answers, kind = this.cfg.kind;
      this.setHeader(this.t.result);
      const menDelta = a.gender === 'men' ? -1 : 0;
      if (kind === 'tracksuit') {
        this.result = [resolveVariant(this.parts[0],this.parts[0].kids ? a.height : a.hoodieSize,menDelta,false), resolveVariant(this.parts[1],this.parts[1].kids ? a.height : a.pantsSize,0,false)];
      } else {
        const delta = kind === 'hoodie' ? menDelta : kind === 'tee' ? (a.fit==='oversized'?-1:-2) : kind === 'shoe' ? this.cfg.delta : 0;
        this.result = [resolveVariant(this.data,a.usual,delta,kind==='shoe')];
      }
      if (/essentials/i.test(this.cfg.title) && kind !== 'shoe' && this.result.some(r => r.belowMinimum)) {
        this.items = null;
        this.body.innerHTML = `${this.brand()}<p class="vp-sf__notice">${escape(this.t.kids_recommendation)}</p><button type="button" class="vp-sf__back" data-sf-restart>${escape(this.t.restart)}</button>`;
        this.dialog.scrollTop = 0;
        this.dialog.querySelector('h2').tabIndex = -1;
        this.dialog.querySelector('h2').focus({preventScroll:true});
        return;
      }
      const valid = this.result.every(r=>r.variant?.available);
      const found = this.result.every(r=>r.variant);
      this.items = valid ? this.result.map((r,i)=>({id:r.variant.id,quantity:1,properties:kind==='tracksuit'?{_bundle_group:this.cfg.bundleBlock}:undefined})) : null;
      let price = this.result.reduce((sum,r)=>sum+(r.variant?.price||0),0);
      const compare = this.result.reduce((sum,r)=>sum+Math.max(r.variant?.compare||0,r.variant?.price||0),0);
      if (kind === 'tracksuit' && this.cfg.currency === 'EUR') price = 14900;
      const saved = compare-price;
      const hoodieReason = this.t[a.gender === 'men' ? 'reason_hoodie_men' : 'reason_hoodie_women'];
      const reason = kind === 'tracksuit' ? [this.parts[0].kids ? '' : hoodieReason, this.parts[1].kids ? '' : this.t.reason_essentials_own].filter(Boolean).join(' ') : kind === 'hoodie' ? hoodieReason : kind === 'tee' ? this.t[a.fit === 'oversized' ? 'reason_tee_oversized' : 'reason_tee_regular'] : kind === 'shoe' ? this.t[this.cfg.delta > 0 ? 'reason_shoe_up' : this.cfg.delta < 0 ? 'reason_shoe_down' : 'reason_shoe_own'] : this.t[/essentials/i.test(this.cfg.title) ? 'reason_essentials_own' : 'reason_bape'];
      const sizes = this.result.length===1 ? `<p class="vp-sf__size">${escape(this.result[0].label)}</p>` : `<div class="vp-sf__pair">${this.result.map((r,i)=>`<div><p>${escape(i===0?this.t.hoodie_label:this.t.pants_label)}</p><strong>${escape(r.label)}</strong></div>`).join('')}</div>`;
      const offer = found ? `<div class="vp-sf__offer"><div class="vp-sf__prices"><strong>${escape(this.money(price))}</strong>${saved>0?`<del>${escape(this.money(compare))}</del>`:''}</div>${saved>0?`<p class="vp-sf__saving">${escape(this.t.save.replace('[amount]',this.money(saved)).replace('[percent]',String(Math.round(saved/compare*100))))}</p>`:''}</div>` : '';
      this.body.innerHTML = `${this.brand()}${sizes}${found&&reason?`<p class="vp-sf__reason">${escape(reason)}</p>`:''}${kind==='tee'?`<p class="vp-sf__fit-label">${escape(this.t[a.fit])}</p>`:''}${valid&&this.result.every(r=>r.variant.fast)?`<p class="vp-sf__fast" aria-label="${escape(this.t.fast)}">48H</p>`:''}${!valid?`<p class="vp-sf__notice">${escape(found?this.t.sold_out:this.t.not_found)}</p>`:''}${offer}${valid?`<button type="button" class="vp-sf__add" data-sf-add><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 7h14l-2 10H8L5 3H2"/><circle cx="9" cy="21" r="1"/><circle cx="17" cy="21" r="1"/></svg><span>${escape(this.t.add)}</span></button>${this.payments}`:''}<p class="vp-sf__error" role="alert" hidden></p><button type="button" class="vp-sf__back" data-sf-restart>${escape(this.t.restart)}</button>`;
      this.dialog.scrollTop = 0;
      this.dialog.querySelector('h2').tabIndex = -1;
      this.dialog.querySelector('h2').focus({preventScroll:true});
    }
    handleClick(event) {
      if (event.target.closest('[data-sf-close]')) { if (!this.busy) this.dialog.close(); return; }
      if (event.target === this.dialog) {
        const r = this.dialog.getBoundingClientRect();
        if (!this.busy && (event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)) this.dialog.close();
        return;
      }
      const answer = event.target.closest('[data-sf-answer]');
      if (answer) { this.answer(answer.dataset.sfAnswer); return; }
      if (event.target.closest('[data-sf-back]')) { this.step--; this.renderQuestion(); return; }
      if (event.target.closest('[data-sf-restart]')) { if (!this.busy) { this.step=0; this.answers={}; this.renderQuestion(); } return; }
      if (event.target.closest('[data-sf-set]')) {
        this.dialog.close();
        this.bundleWrapper?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
        this.bundleWrapper?.querySelector('[data-addon-card]')?.focus({preventScroll:true});
        return;
      }
      if (event.target.closest('[data-sf-add]')) this.addToCart();
    }
    async addToCart() {
      if (this.busy || !this.items?.length) return;
      this.busy = true;
      const button = this.body.querySelector('[data-sf-add]');
      const errorEl = this.body.querySelector('.vp-sf__error');
      button.disabled = true;
      button.querySelector('span').textContent = this.t.adding;
      errorEl.hidden = true;
      try {
        let body,headers;
        if (this.cfg.kind === 'tracksuit') {
          const cards = [...this.bundleWrapper.querySelectorAll('[data-addon-card].is-selected')];
          if (this.parts.some(p=>!cards.includes(p.card))) throw new Error(this.t.select_set);
          body = JSON.stringify({items:this.items});
          headers = {'Content-Type':'application/json',Accept:'application/json'};
        } else {
          const form = document.getElementById(this.dataset.form);
          body = form ? new FormData(form) : new FormData();
          body.set('id',String(this.items[0].id));
          if (!body.get('quantity')) body.set('quantity','1');
          body.delete('sections');
          headers = {Accept:'application/json'};
        }
        const response = await fetch(this.root+'cart/add.js',{method:'POST',headers,body});
        if (!response.ok) {
          const error = await response.json().catch(()=>({}));
          throw new Error(typeof error.description==='string'?error.description:this.t.error);
        }
        window.location.assign(this.cfg.cartUrl);
      } catch (error) {
        this.busy = false;
        button.disabled = false;
        button.querySelector('span').textContent = this.t.add;
        errorEl.textContent = error.message || this.t.error;
        errorEl.hidden = false;
      }
    }
  }
  customElements.define('vp-size-finder',VuoplugSizeFinder);
})();
